import React, { useState } from "react";
import { DateTime } from "luxon";
import styles from "./LastCommentBubble.module.scss";

/**
 * Composant pour afficher le dernier commentaire au survol d'une icône de bulle
 * @param {Array} commentaires - Liste des commentaires
 * @returns {JSX.Element|null} Le composant ou null si pas de commentaires
 */
const LastCommentBubble = ({ commentaires }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Vérifier s'il y a des commentaires
  if (!commentaires || commentaires.length === 0) {
    return null;
  }

  // Trouver le dernier commentaire (le plus récent)
  const lastComment = commentaires.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  )[0];

  console.log("lastComment", lastComment);

  // Formater la date relative
  const formatRelativeDate = (dateString) => {
    const date = DateTime.fromISO(dateString);
    const now = DateTime.now();
    const diff = now.diff(date, ["days", "hours", "minutes"]);

    if (diff.days > 0) {
      return `il y a ${Math.floor(diff.days)} jour${diff.days > 1 ? "s" : ""}`;
    } else if (diff.hours > 0) {
      return `il y a ${Math.floor(diff.hours)}h`;
    } else if (diff.minutes > 0) {
      return `il y a ${Math.floor(diff.minutes)}min`;
    } else {
      return "à l'instant";
    }
  };

  // Tronquer le commentaire s'il est trop long
  const truncateComment = (comment, maxLength = 150) => {
    if (comment.length <= maxLength) return comment;
    return comment.substring(0, maxLength) + "...";
  };

  return (
    <div className={styles.commentBubbleContainer}>
      <i
        className={`fas fa-comment-dots text-orange ${styles.commentIcon}`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        title="Dernier commentaire"
      />

      {showTooltip && (
        <div className={styles.tooltip}>
          <div className={styles.tooltipHeader}>
            <span className={styles.author}>{lastComment.nom}</span>
            <span className={styles.date}>
              {formatRelativeDate(lastComment.created_at)}
            </span>
          </div>
          <div className={styles.tooltipContent}>
            {truncateComment(lastComment.commentaire)}
          </div>
          <div className={styles.tooltipArrow}></div>
        </div>
      )}
    </div>
  );
};

export default LastCommentBubble;
